import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CustomResponse } from 'src/app/interfaces/CustomResponse';
import { Aac_PermitionDto } from 'src/app/models/afs/aac_PermitionDto';
import { AuthServiceCustom } from '../../core/auth/authServiceCustom';
import { AppConfig } from '../../core/_config/app.config';
@Injectable({
    providedIn: 'root',
})
export class Aac_PermitionService {
    private API_URL = this.config.urlApi + this.config.versionApi;
    constructor(private http: HttpClient, private config: AppConfig, public authServiceCustom: AuthServiceCustom) {}

    public GetEntityPermission(): Observable<CustomResponse<Aac_PermitionDto>> {
        let username = this.authServiceCustom.userName;
        if (!username) return;

        let url = `${this.API_URL}Entity/GetEntityPermission/${username}`;
        return this.http.get<CustomResponse<Aac_PermitionDto>>(url, {});
    }
}
